import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import type { FC, PropsWithChildren } from 'react';
import styles from './modal-headline.module.css';

export const ModalHeadline: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Headline renderAs="div" size="s" className={styles.headline}>
      {children}
    </Headline>
  );
};
